import { Box } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { BorrowingBaseReportGQLType } from 'types/dashboard-core-gqlTypes.generated';

import { BorrowingBaseSummaryCash } from './BorrowingBaseSummaryCash';
import { BorrowingBaseSummaryFacilitySummary } from './BorrowingBaseSummaryFacilitySummary';
import { BorrowingBaseSummaryFinalBorrowingBaseReport } from './BorrowingBaseSummaryFinalBorrowingBaseReport';
import { BorrowingBaseSummaryReceivables } from './BorrowingBaseSummaryReceivables';
import { BorrowingBaseSummarySections } from './utils';
import { colors } from 'packages/common-frontend/colors';

export const BorrowingBaseSummaryWithSingleValue: React.FC<{
  sections: BorrowingBaseSummarySections[];
  borrowingBaseReport: BorrowingBaseReportGQLType;
  creditAgreement: CreditAgreement.DomainEntity.CreditAgreementFullArtifact;
}> = ({ sections, borrowingBaseReport, creditAgreement }) => {
  const includesSection = (section: BorrowingBaseSummarySections) =>
    _.includes(sections, section);

  const showComparisonAndDifferenceColumns = false;

  return (
    <Box
      mb="24px"
      padding="16px 24px"
      borderRadius="8px"
      border={`1px solid ${colors.gray[200]}`}
      backgroundColor="white"
    >
      {includesSection(BorrowingBaseSummarySections.facilitySummary) && (
        <BorrowingBaseSummaryFacilitySummary
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(BorrowingBaseSummarySections.receivables) && (
        <BorrowingBaseSummaryReceivables
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(BorrowingBaseSummarySections.cash) && (
        <BorrowingBaseSummaryCash
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          creditAgreement={creditAgreement}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
      {includesSection(
        BorrowingBaseSummarySections.finalBorrowingBaseReport,
      ) && (
        <BorrowingBaseSummaryFinalBorrowingBaseReport
          borrowingBaseReports={{
            minuendBorrowingBaseReport: borrowingBaseReport,
          }}
          showComparisonAndDifferenceColumns={
            showComparisonAndDifferenceColumns
          }
        />
      )}
    </Box>
  );
};
